const deconstructQuery = (queryString) => {
  let decodedTerms = queryString.replace('?onbrand=', '');
  decodedTerms = decodedTerms.replace('?', '');
  decodedTerms = decodedTerms.replace('=', '');
  decodedTerms = decodedTerms.replace('%2C', ',');
  decodedTerms = decodedTerms.replace('%2C', ',');
  decodedTerms = decodedTerms.replace('%20', ' ');
  decodedTerms = decodedTerms.replace(',NAN', '');
  let searchTerms = decodedTerms.split(',');
  if (searchTerms[0] === '') {
    searchTerms = [];
  }
  return searchTerms;
};

const createUrl = () => {
  let queryUrl;
  if (window.hasOnbrand) {
    queryUrl = `?onbrand=`;
    // window.urlStorage
    Object.keys(window.urlStorage).map((section) => {
      if (window.urlStorage) {
        if (typeof window.urlStorage[section][1] === 'number') {
          queryUrl += `${section},${window.urlStorage[section][0]},${
            window.urlStorage[section][1]
          }`;
        } else if (typeof window.urlStorage[section][0] === 'number') {
          queryUrl += `${section},${window.urlStorage[section][0]}`;
        } else {
          queryUrl += `${section}`;
        }
      }
      return queryUrl;
    });
    return queryUrl;
  }

  queryUrl = '?';
  Object.keys(window.urlStorage).map((section) => {
    if (window.urlStorage) {
      if (typeof window.urlStorage[section][1] === 'number') {
        queryUrl += `${section},${window.urlStorage[section][0]},${
          window.urlStorage[section][1]
        }`;
      } else if (typeof window.urlStorage[section][0] === 'number') {
        queryUrl += `${section},${window.urlStorage[section][0]}`;
      } else {
        queryUrl += `${section}`;
      }
    }
    return queryUrl;
  });

  return queryUrl;
};

const setQueryParams = () => {
  const queryUrl = createUrl();
  history.replaceState(null, null, queryUrl);
};

// stores expanded content info and sets the query string
const storeUrlState = (urlParameters, level1, level2) => {
  window.urlStorage = {};
  if (typeof level1 === 'number' || level1 === null) {
    window.urlStorage[urlParameters] = [level1];

    if (typeof level2 === 'number' || level2 === null) {
      window.urlStorage[urlParameters] = [level1, level2];
    }
  }
  setQueryParams();
};

// on load grabs the query strings and opens required items.
const setUrlState = () => {
  const queryString = window.location.search;
  const queryArray = deconstructQuery(queryString);
  if (queryArray[0] !== undefined) {
    storeUrlState(
      queryArray[0],
      queryArray[1] === undefined ? null : parseInt(queryArray[1]),
      queryArray[2] === undefined ? null : parseInt(queryArray[2])
    );
  }

  if (queryArray.length >= 1) {
    // close everything
    // close level 0
    $('.faq-links > div').css('display', 'none');

    // close level 1
    $('.level-1 .expandable-content-wrapper').slideUp(400);
    $('.level-1 .expandable-content-wrapper')
      .slideUp(400)
      .removeClass('open');

    // close level 2
    $('.expanded')
      .slideUp(400)
      .removeClass('expanded');

    // open necessary compartments
    if (queryArray.length === 3) {
      // open level 0
      const level0 = $(`#${queryArray[0]}`);
      level0.css('display', 'block');
      // open level 1
      const level1Num = parseInt(queryArray[1]) + 1;
      const level1 = $(
        `#${
          queryArray[0]
        } .level-1>li:nth-child(${level1Num})>.expandable-content-wrapper`
      );
      level1.addClass('open');
      level1.slideDown(400);
      // open level 2
      const level2Num = parseInt(queryArray[2]) + 1;
      const level2 = level1.find(
        `.expandable-content:nth-of-type(${level2Num})`
      );
      level2.find('ul').slideDown(400);
      level2.addClass('expanded');
    } else if (queryArray.length === 2) {
      // open level 0
      const level0 = $(`#${queryArray[0]}`);
      level0.css('display', 'block');

      // open level 1
      const level1Num = parseInt(queryArray[1]) + 1;
      const level1 = $(
        `#${
          queryArray[0]
        } .level-1>li:nth-child(${level1Num})>.expandable-content-wrapper`
      );
      level1.slideDown(400);
    } else if (queryArray.length === 1) {
      // open level 0
      const level0 = $(`#${queryArray[0]}`);
      level0.slideDown(400);

      // if there is only one li open that li
      if (level0.find('.expandable-content-wrapper').length < 2) {
        level0
          .find('.expandable-content-wrapper')
          .slideDown(400)
          .addClass('open');
        storeUrlState(queryArray[0], 0, null);
      }
    }
  }
};

const controlExpandableContent = () => {
  // LEVEL 2
  $('.expandable-content p').on('click', function() {
    // toggle level 2 content
    const parent = $(this).parent();
    $(this)
      .siblings('ul')
      .slideToggle(400);
    parent.toggleClass('expanded');

    $('.expandable-content p')
      .not($(this))
      .siblings('ul')
      .slideUp(400);

    $('.expandable-content')
      .not(parent)
      .removeClass('expanded');

    /* ----------- Set URL State---------- */
    // get level 0 id
    const containerID = $(this)
      .closest('div[id]')
      .attr('id');
    // get level 1 index
    const indexLvl1 = $(`#${containerID} .level-1>li`).index(
      $(this).closest('.level-1>li')
    );

    const indexLvl2 = $(this)
      .closest('.expandable-content-wrapper')
      .find('.expandable-content')
      .index($(this).parent());

    //determine if level 2 is open or closed
    const indexLvl2Final = $(this)
      .parent()
      .hasClass('expanded')
      ? indexLvl2
      : null;

    if ($('.level-1').length > 0) {
      storeUrlState(containerID, indexLvl1, indexLvl2Final);
    }
  });
};

const FaqHandler = () => {
  // LEVEL 0
  $('.faq-navigation li a[href*=\\#]').on('click', function(e) {
    e.preventDefault();
    const targetDiv = $(this).attr('href');

    // get level 0 id
    const targetID = targetDiv.replace('#', '');
    if ($('.level-1').length > 0) {
      storeUrlState(targetID, null, null);
    }
    $('.faq-links > div')
      .not($(targetDiv))
      .css('display', 'none');
    $(targetDiv).fadeIn(400);
    if ($(targetDiv).find('h3').length <= 1) {
      $(targetDiv)
        .find('.expandable-content-wrapper')
        .addClass('open')
        .css('display', 'block');
      storeUrlState(targetID, 0, null);
    }
  });

  // LEVEL 1
  $('.faq-links h3').on('click', (e) => {
    const targetDropdown = $(e.target).siblings('.expandable-content-wrapper');
    targetDropdown.slideToggle(400);
    targetDropdown.toggleClass('open');

    $('.expandable-content-wrapper')
      .not(targetDropdown)
      .slideUp(400)
      .removeClass('open');

    // get level0 ID
    const containerID = $(e.target)
      .closest('div[id]')
      .attr('id');
    // get the index of the expandable item clicked
    const indexLvl1 = $(`#${containerID} .level-1>li`).index(
      $(e.target).parent()
    );

    const indexLvl1Final = targetDropdown.hasClass('open') ? indexLvl1 : null;
    if (indexLvl1Final === null) {
      // close level2
      $('.expanded').slideUp(400);
      $('.expanded').removeClass('expanded');
    }

    if ($('.level-1').length > 0) {
      storeUrlState(containerID, indexLvl1Final, null);
    }
  });
};

module.exports = { FaqHandler, controlExpandableContent, setUrlState };



// WEBPACK FOOTER //
// ./partial-scripts/expandableContent.js